import {useIsRegistrationWizardTreatment} from "../../auth/hooks/use_is_registration_wizard_treatment";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useIsAuthenticated} from "../../user/hooks/use_is_authenticated";

interface IConstructionPhotosAccess {
    hasAccess: boolean;
    /** A logged-in user of the registration wizard has to verify the phone before seeing the photos */
    needsPhoneVerification: boolean;
    /** The loaded profile has no verified phone - the arms of the registration wizard experiment show this user the photos differently */
    isLoggedInWithoutVerifiedPhone: boolean;
}

export const useConstructionPhotosAccess = (): IConstructionPhotosAccess => {
    const isAuthenticated = useIsAuthenticated();
    const {isUserLoggedIn, hasPhoneVerified} = useShouldHidePrices();
    const isRegistrationWizardTreatment = useIsRegistrationWizardTreatment();
    const isLoggedInWithoutVerifiedPhone = isUserLoggedIn && !hasPhoneVerified;
    const needsPhoneVerification = isLoggedInWithoutVerifiedPhone && isRegistrationWizardTreatment;

    return {
        hasAccess: isAuthenticated && !needsPhoneVerification,
        needsPhoneVerification,
        isLoggedInWithoutVerifiedPhone
    };
};
import {useIsRegistrationWizardTreatment} from "../../auth/hooks/use_is_registration_wizard_treatment";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useIsAuthenticated} from "../../user/hooks/use_is_authenticated";

interface IConstructionPhotosAccess {
    hasAccess: boolean;
    /** A logged-in user of the registration wizard has to verify the phone before seeing the photos */
    needsPhoneVerification: boolean;
    /** The loaded profile has no verified phone - the arms of the registration wizard experiment show this user the photos differently */
    isLoggedInWithoutVerifiedPhone: boolean;
}

export const useConstructionPhotosAccess = (): IConstructionPhotosAccess => {
    const isAuthenticated = useIsAuthenticated();
    const {isUserLoggedIn, hasPhoneVerified} = useShouldHidePrices();
    const isRegistrationWizardTreatment = useIsRegistrationWizardTreatment();
    const isLoggedInWithoutVerifiedPhone = isUserLoggedIn && !hasPhoneVerified;
    const needsPhoneVerification = isLoggedInWithoutVerifiedPhone && isRegistrationWizardTreatment;

    return {
        hasAccess: isAuthenticated && !needsPhoneVerification,
        needsPhoneVerification,
        isLoggedInWithoutVerifiedPhone
    };
};
